import guest from '../middleware/guest';

export default {
    path: '/autorizacija',
    name: 'auth',
    meta: {
        middleware: [guest]
    },
    component: () => import('@/views/auth/Auth'),
};